import * as React from 'react';
import { pure } from 'recompose';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { Menu, MenuItem, Image, Icon } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import * as Routes from '../routes';
const logo = require('../theme/img/prooph-software-logo-icon.png');

const TopMenu = pure((props: any) => {
    return (
        <Menu fixed="top" inverted={true}>
            <MenuItem active={false}>
                <Image src={logo} height={20}/>
            </MenuItem>
            <MenuItem
                as={NavLink}
                to={Routes.inspectioPath}
                activeClassName="active">
                <Icon name="exchange" color="blue" />
                {props.t('app.sidemenu.inspectio')}
            </MenuItem>
        </Menu>
    );
});

export default withRouter(translate('translation')(TopMenu));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Layout/TopMenu.tsx